import * as L from 'leaflet';
import { faBrightnessLow } from '@fortawesome/pro-regular-svg-icons';
import { clickOutsideHandler, createBasicLeafletIconButton, toggleActiveClass } from './helpers';

export class ControlOpacity extends L.Control {
  private inputContainer: HTMLElement;
  valueChanged: (opacity: number) => void;

  constructor(public options: Partial<L.ControlOptions> & {opacity: number}) {
    super(options);
  }

  onAdd(map: L.Map) {
    const container = L.DomUtil.create('div', 'position-relative control-opacity');
    const anchorElement = createBasicLeafletIconButton(faBrightnessLow);
    container.appendChild(anchorElement);

    const inputContainer = L.DomUtil.create('div', 'd-flex bg-white position-absolute d-none leaflet-box-shadow');
    this.inputContainer = inputContainer;
    inputContainer.style.width = '120px';
    inputContainer.style.boxShadow = 'box-shadow: 0px 4px 4px 0px #00000040';
    inputContainer.style.height = '20px';
    inputContainer.style.left = '-126px';
    inputContainer.style.top = '5px';
    inputContainer.style.borderRadius = '2px';
    inputContainer.style.padding = '0 4px';

    const rangeWrap = L.DomUtil.create('div', 'position-relative');

    const input = L.DomUtil.create('input', 'w-100');
    const outputBubble = L.DomUtil.create('output', 'bubble');
    rangeWrap.appendChild(input);
    rangeWrap.appendChild(outputBubble);

    input.type = 'range';
    input.defaultValue = ((this.options?.opacity ?? 1) * 100)?.toString();
    input.min = '10';
    input.max = '100';
    input.onwheel = event => {
      if (event.deltaY < 0){
        input.stepUp(1);
      }else{
        input.stepDown(1);
      }
      input.dispatchEvent(new Event('input'));

      event.preventDefault();
      event.stopPropagation();
    }

    input.oninput = () => {
      map.eachLayer(layer => {
        if (layer instanceof L.ImageOverlay && layer.options.className !== 'qpoint-pdf-backdrop') {
          layer.setOpacity(input.valueAsNumber / 100)
        }
        this.valueChanged(input.valueAsNumber / 100);
        this.setBubble(input, outputBubble);
      });
    }
    this.setBubble(input, outputBubble);

    L.DomEvent.disableScrollPropagation(input);


    inputContainer.appendChild(rangeWrap);

    container.append(inputContainer);

    anchorElement.onclick = () => {
      this.toggleOpacity();
      toggleActiveClass(container);
    };

    clickOutsideHandler(
      [container, inputContainer],
      () => {
        if(!this.inputContainer.classList.contains('d-none')) {
          this.toggleOpacity();
          toggleActiveClass(container);
        }
      },
      map.getContainer()
    )

    return container;
  }

  toggleOpacity() {
    this.inputContainer.classList.toggle('d-none');
  }

  private setBubble(range: HTMLInputElement, bubble: HTMLOutputElement) {
    const val = +range.value;
    const min = range.min ? +range.min : 10;
    const max = range.max ? +range.max : 100;
    const newVal = Number(((val - min) * 90) / (max - min));
    bubble.innerHTML = val.toString();

    // Sorta magic numbers based on size of the native UI thumb
    bubble.style.left = `${(newVal + 5)}%`;
  }
}
